import { z } from 'zod';

export const ThresholdConfigSchema = z.object({
  warn: z.number().int().nonnegative(),
  block: z.number().int().nonnegative()
});
export type ThresholdConfig = z.infer<typeof ThresholdConfigSchema>;

export const DiffThresholdsSchema = z.object({
  enumChanges: ThresholdConfigSchema,
  actionChanges: ThresholdConfigSchema,
  routeChanges: ThresholdConfigSchema,
  fieldChanges: ThresholdConfigSchema
});
export type DiffThresholds = z.infer<typeof DiffThresholdsSchema>;

export const DEFAULT_DIFF_THRESHOLDS: DiffThresholds = {
  enumChanges: { warn: 1, block: 3 },
  actionChanges: { warn: 2, block: 5 },
  routeChanges: { warn: 5, block: 15 },
  fieldChanges: { warn: 10, block: 25 }
};

export const RiskLevelSchema = z.enum(['low', 'medium', 'high', 'critical']);
export type RiskLevel = z.infer<typeof RiskLevelSchema>;

export const DiffSeveritySchema = z.enum(['info', 'warn', 'block']);
export type DiffSeverity = z.infer<typeof DiffSeveritySchema>;

export function computeSeverity(changeCount: number, threshold: ThresholdConfig): DiffSeverity {
  if (changeCount >= threshold.block) {
    return 'block';
  }
  if (changeCount >= threshold.warn) {
    return 'warn';
  }
  return 'info';
}
